<div class="installments-slider" [ngClass]="type">
    <div class="slider">
        <div class="slider-bar" [ngStyle]="{'width': progress}"></div>
    </div>
    @if (showInstallments) {
        <div class="rate" [ngStyle]="{'left': getLeftPosition(distance)}">Rata <i>{{ payedInstallments }}</i>/{{ maxInstallments }}</div>
    }
</div>
